import * as React from 'react'
import * as CopyToClipboard from 'react-copy-to-clipboard'
import aqe from '@pushly/aqe'

interface IAddUserSuccessMessage {
    responseData: any
    showMessage?: boolean
    message?: string | ((data: any) => string)
    type?: 'invite' | 'password'
    hostnameOverride?: string
}

interface IAddUserSuccessMessageState {
    copied: boolean
}

export class AddUserSuccessMessage extends React.Component<IAddUserSuccessMessage, IAddUserSuccessMessageState> {
    public state: IAddUserSuccessMessageState = {
        copied: false,
    }

    public render() {
        let message = 'User was successfully saved.'
        if (this.props.message) {
            message =
                typeof this.props.message === 'function'
                    ? this.props.message(this.props.responseData)
                    : this.props.message
        }

        return <span>{this.props.showMessage && message}</span>
    }
}
